import api from '../baseApi';
import { DesignTemplate, DesignTemplatesListResult } from '../typings/designTemplates';

export const listDesignTemplates = async (
    from: number,
    count: number,
    search?: string,
    sortBy?: string,
    sortMode?: string
): Promise<DesignTemplatesListResult> => {
    const response = await api.get('/Admin/DesignTemplates', {
        params: {
            from,
            count,
            search,
            sortBy,
            sortMode
        }
    });
    return response.data;
};

export const getDesignTemplate = async (id: string, useListEPS = false): Promise<DesignTemplate> => {
    const response = await api.get(`/Admin/DesignTemplates/${id}`, {
        params: {
            useListEPS
        }
    });
    return response.data;
};

export const saveDesignTemplate = async (designTemplate: DesignTemplate, id?: string): Promise<DesignTemplate> => {
    const url = id ? `/Admin/DesignTemplates/${id}` : '/Admin/DesignTemplates';
    const response = await api.put(url, designTemplate);
    return response.data;
};

export const cloneDesignTemplate = async (id: string): Promise<DesignTemplate> => {
    const response = await api.post(`/Admin/DesignTemplates/${id}/Clone`);
    return response.data;
};

export const deleteDesignTemplate = async (id: string): Promise<DesignTemplate> => {
    const response = await api.delete(`/Admin/DesignTemplates/${id}`);
    return response.data;
};

export const createSetFromDesignTemplate = async (
    id: string
): Promise<{
    setId: string;
    taskIdentifier: string;
}> => {
    const response = await api.post(`/Admin/DesignTemplates/${id}/OptionSet`);
    return response.data;
};
